function functionalKeys(event, _dev) {

  // f1 is typically help
  if (event.key == 'F1') {
    event.preventDefault();
    // console.log("f1");
  }

  if (event.key == 'F2') {
    event.preventDefault();
    // console.log("f2");
  }

  // f3 is typically search
  if (event.key == 'F3') {
    event.preventDefault();
    // console.log("f3");
  }

  if (event.key == 'F4') {
    event.preventDefault();
    // console.log("f4");
  }

  if (!_dev) {
    // f5 is typically refresh
    if (event.key == 'F5') {
      event.preventDefault();
      // console.log("f5");
    }
  }

  if (event.key == 'F6') {
    event.preventDefault();
    // console.log("f6");
  }

  // f7 is typically using keyboard mode
  if (event.key == 'F7') {
    event.preventDefault();
    // console.log("f7");
  }

  if (event.key == 'F8') {
    event.preventDefault();
    // console.log("f8");
  }

  if (event.key == 'F9') {
    event.preventDefault();
    // console.log("f9");
  }

  if (event.key == 'F10') {
    event.preventDefault();
    // console.log("f10");
  }

  // f11 is typically full screen mode
  if (event.key == 'F11') {
    event.preventDefault();
    // console.log("f11");
  }

  if (!_dev) {
    // f12 is typically devtools
    if (event.key == 'F12') {
      event.preventDefault();
      // console.log("f12");
    }
  }
}

export { functionalKeys }